import Construction from "../components/Construction";


function Pricing() {
  return (
    <>
    <Construction />
    </>
  );
}

export default Pricing;
